import styled from "styled-components";

export const ThemedTitle = styled.h1`
  font-family: ${(props) => props.theme.font || "Source Sans Pro"};
  font-weight: 400;
  font-size: 24px;
  color: white;
`;

